/** The shop works in Slovak time, not the visitor's (cut-off, opening hours). */
const STORE_TIME_ZONE = 'Europe/Bratislava';

/**
 * `now` in the store time zone: the calendar date (as UTC midnight), the weekday (0 = Monday … 6 =
 * Sunday, the order of „Kontakt - pracovná doba“) and the minutes since midnight. Client-safe.
 */
export function storeClock(now: Date) {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat('en-US', {
      timeZone: STORE_TIME_ZONE,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hourCycle: 'h23',
    })
      .formatToParts(now)
      .map(part => [part.type, Number(part.value)]),
  );
  const today = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
  return {
    today,
    weekday: (today.getUTCDay() + 6) % 7,
    minutes: parts.hour * 60 + parts.minute,
  };
}
